"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textColors = exports.sizes = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _range = _interopRequireDefault(require("lodash/range"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["size", "autoFocus", "transparent", "type", "value", "length", "onChange", "invalid", "disabled", "separator", "onKeyDown", "Digit"],
  _excluded2 = ["standalone", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var KEY_CODE = {
  backspack: 8,
  left: 37,
  right: 39,
  up: 38,
  down: 40
};
var sizes = exports.sizes = {
  sm: 'py-0 px-3 text-xs',
  md: 'py-1 px-4',
  lg: 'py-2 px-5'
};
var textColors = exports.textColors = {
  disabled: 'text-light',
  normal: 'text-medium'
};
var DigitInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === void 0 ? false : _ref$transparent,
    type = _ref.type,
    value = _ref.value,
    length = _ref.length,
    onChange = _ref.onChange,
    invalid = _ref.invalid,
    disabled = _ref.disabled,
    separator = _ref.separator,
    onKeyDown = _ref.onKeyDown,
    _ref$Digit = _ref.Digit,
    Digit = _ref$Digit === void 0 ? DefaultItem : _ref$Digit,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    cursor = _useState2[0],
    setCursor = _useState2[1];
  var inputRefs = (0, _react.useRef)(new Array(length).fill(null));
  var isMounted = (0, _react.useRef)(false);
  var current = (0, _react.useMemo)(function () {
    var val = typeof value === 'undefined' ? '' : value.toString();
    return {
      value: val,
      length: val.length
    };
  }, [value]);
  function refocusWrapper(fn) {
    return function (target) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (force && target) {
        fn(target);
      }
      var currTarget = inputRefs.current[cursor || 0];
      if (currTarget && target && currTarget !== target) {
        if (currTarget.value.length === 0 && target.value.length === 0) {
          return;
        }
        fn(target);
      } else if (target) {
        fn(target);
      }
    };
  }
  var selectInput = refocusWrapper(function (target) {
    return target.select();
  });
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        return handleOnFocus();
      },
      value: function value() {
        return current.value;
      }
    };
  });
  (0, _react.useEffect)(function () {
    if (!isMounted.current && !autoFocus) {
      isMounted.current = true;
      return;
    }
    if (typeof cursor === 'number') {
      var nextCursor;
      if (cursor + 1 < current.length) {
        nextCursor = cursor;
      } else {
        nextCursor = current.length === length ? length - 1 : current.length;
      }
      var next = inputRefs.current[nextCursor];
      var nextCursorVal = current.value[nextCursor];
      var isEnd = nextCursor + 1 === length;
      if (!nextCursorVal) {
        selectInput(next);
      } else if (!isEnd) {
        selectInput(next);
      }
    }
  }, [value]);
  function handleOnChange(c, i) {
    var next = current.value.slice(0, i) + c.slice(-1) + current.value.slice(i + 1);
    var nextTarget = inputRefs.current[!c ? i : i + 1];
    selectInput(nextTarget);
    if (next !== current.value && onChange) {
      onChange(next);
    }
  }
  function handleOnPaste(e, i) {
    var _e$clipboardData;
    e.preventDefault();
    var data = ((_e$clipboardData = e.clipboardData) === null || _e$clipboardData === void 0 || (_e$clipboardData = _e$clipboardData.getData('TEXT')) === null || _e$clipboardData === void 0 ? void 0 : _e$clipboardData.trim()) || '';
    var nextValue = current.value.slice(0, i) +
    // Filter out the non-alnum characters from the clipboard
    data.replace(/[^0-9a-zA-Z]/gi, '').slice(0, length - i);
    selectInput(inputRefs.current[nextValue.length - 1], true);
    if (onChange) onChange(nextValue);
  }
  function handleOnFocus(e, i) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    var toFocusedCursor;
    if (typeof i === 'number' && !!current.value[i]) {
      toFocusedCursor = i;
    } else {
      toFocusedCursor = current.length === length ? length - 1 : current.length;
    }
    var focused = inputRefs.current[toFocusedCursor];
    if (focused) {
      setCursor(toFocusedCursor);
      selectInput(focused, toFocusedCursor === cursor);
    }
  }
  function handleOnKeyDown(e, i) {
    var prev = inputRefs.current[i - 1];
    var next = inputRefs.current[i + 1];
    var key = e.key,
      keyCode = e.keyCode,
      target = e.currentTarget;
    switch (keyCode) {
      case KEY_CODE.backspack:
        e.preventDefault();
        handleOnChange('', !!current.value[i] ? i : i - 1);
        break;
      case KEY_CODE.left:
        e.preventDefault();
        if (prev) {
          selectInput(prev);
        }
        break;
      case KEY_CODE.right:
        e.preventDefault();
        if (next) {
          selectInput(next);
        }
        break;
      default:
        break;
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  }
  function handleOnInput(e, i) {
    var target = e.target;
    var value = target.value;
    if ([['0', '9'], ['a', 'z'], ['A', 'Z']].some(function (_ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        start = _ref3[0],
        end = _ref3[1];
      return value.length === 1 && value.codePointAt(0) >= start.codePointAt(0) && value.codePointAt(0) <= end.codePointAt(0);
    })) {
      e.preventDefault();
      handleOnChange(value, i);
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])(sizes[size], 'overflow-auto rounded px-4 flex items-center flex-nowrap', (0, _defineProperty2["default"])((0, _defineProperty2["default"])({
      'bg-secondary': !transparent
    }, textColors.disabled, disabled), textColors.normal, !disabled), props.className),
    onClick: handleOnFocus
  }), (0, _range["default"])(length).map(function (_, i, src) {
    var digitValue = current.value[i] || '';
    var digit = /*#__PURE__*/_react["default"].createElement(Digit, {
      key: i,
      index: i,
      disabled: disabled,
      invalid: invalid,
      value: digitValue,
      source: current.value,
      isFocus: cursor === i,
      isPassword: type === 'password'
    }, /*#__PURE__*/_react["default"].createElement("input", {
      autocomplete: "new-password",
      ref: function ref(node) {
        return inputRefs.current[i] = node;
      },
      size: "1",
      type: type,
      autoFocus: autoFocus && i === 0,
      disabled: disabled,
      value: digitValue,
      className: (0, _classnames["default"])('text-center !bg-transparent !h-full !w-full', {
        'cursor-default opacity-0': i > current.length
      }),
      style: {
        fontSize: 'inherit',
        fontWeight: 'inherit'
      },
      onPaste: function onPaste(e) {
        return handleOnPaste(e, i);
      },
      onInput: function onInput(e) {
        return handleOnInput(e, i);
      },
      onClick: function onClick(e) {
        return handleOnFocus(e, i);
      },
      onKeyDown: function onKeyDown(e) {
        return handleOnKeyDown(e, i);
      },
      onFocus: function onFocus() {
        return setCursor(i);
      },
      onBlur: function onBlur(e) {
        return cursor === i && setCursor(undefined);
      }
    }));
    if (!!separator && (i + 1) % 4 === 0 && i !== src.length - 1) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: i
      }, digit, /*#__PURE__*/_react["default"].createElement(Separator, null, separator));
    } else {
      return digit;
    }
  }));
});
var Separator = function Separator(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "cursor-default selct-none text-light text-center opacity-75 mr-1"
  }));
};
var DefaultItem = function DefaultItem(_ref4) {
  var _ref4$invalid = _ref4.invalid,
    invalid = _ref4$invalid === void 0 ? false : _ref4$invalid,
    value = _ref4.value,
    children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      width: '2.1ch'
    },
    className: (0, _classnames["default"])('py-1 mr-1 last:mr-0 border-b', {
      'border-light': !!value,
      'border-red': !value && invalid
    })
  }, children);
};
var Input = function Input(_ref5) {
  var standalone = _ref5.standalone,
    _onChange = _ref5.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded2);
  var length = typeof props.length === 'number' ? props.length : parseInt(props.length);
  return standalone ? /*#__PURE__*/_react["default"].createElement(DigitInput, (0, _extends2["default"])({}, props, {
    onChange: _onChange
  })) : /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: props.name,
    render: function render(_ref6) {
      var field = _ref6.field,
        form = _ref6.form;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, field, {
        disabled: true,
        name: props.name,
        defaultValue: props.value,
        className: "hidden"
      })), /*#__PURE__*/_react["default"].createElement(DigitInput, (0, _extends2["default"])({}, props, field, {
        length: length,
        onBlur: undefined,
        onChange: function onChange(nextValue) {
          if (nextValue.length <= length) {
            form.setFieldValue(field.name, nextValue);
            if (_onChange) {
              _onChange(nextValue);
            }
          }
        }
      })));
    }
  });
};
Input.displayName = 'DigitInput';
Input.defaultProps = {
  standalone: false,
  size: 'md',
  className: '',
  disabled: false,
  invalid: false,
  value: '',
  type: 'text',
  separator: '/'
};
var _default = exports["default"] = Input;
//# sourceMappingURL=DigitInput.js.map